/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getDispute} from '../api'

 export const useQueryGetDispute = createReactQueryHook('getDispute', getDispute)
